import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { painPoints } from '../../data/content';
import { getIcon } from '../../utils/icons';
export function PainPoints() {
  return <section className="bg-navy-950 px-4 py-16 sm:py-24" aria-labelledby="pain-title" data-id="element-319" data-mp="27nvdwweb27fn">
      <div className="mx-auto max-w-6xl" data-id="element-320" data-mp="22usjkm1petye">
        <SectionHeading tone="dark" title={<span id="pain-title" data-id="element-322" data-mp="2hj6uzld6rqqk">Do you recognize yourself in any of these situations?</span>} subtitle="If you answer YES to any of these questions, I created this educational collection with your learning needs in mind." data-id="element-321" data-mp="22tr66ax7tvdi" />

        <ul className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-323" data-mp="2qitx69dqp0ko">
          {painPoints.map(p => {
          const Icon = getIcon(p.icon);
          return <li key={p.title} className="flex gap-4 rounded-3xl bg-navy-900 p-5 ring-1 ring-white/5 sm:p-6" data-id="element-324" data-mp="w7x2ilvnn9b9">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-cta text-navy-950" data-id="element-325" data-mp="s74tntqp36fi">
                  <Icon className="h-6 w-6" strokeWidth={2.5} aria-hidden="true" data-id="element-326" data-mp="1n5yzcptmpj6h" />
                </span>
                <div data-id="element-327" data-mp="1s4jyelx59wtc">
                  <h3 className="text-lg font-extrabold leading-snug text-white" data-id="element-328" data-mp="1x5hhd0pzauvw">{p.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-mist" data-id="element-329" data-mp="21wg1yci02f4y">{p.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-12 max-w-3xl text-center" data-id="element-330" data-mp="26xvm82ccshma">
          <p className="text-base leading-relaxed text-mist sm:text-lg" data-id="element-331" data-mp="2awcwgur2m87x">
            And it shouldn’t be necessary to search through dozens of disconnected resources every time you want to
            review a topic.
          </p>
          <p className="mt-6 text-2xl font-black leading-tight text-white text-balance sm:text-3xl" data-id="element-332" data-mp="2kusjalj2evbm">
            Sometimes the problem isn’t a lack of information.{' '}
            <span className="text-cta" data-id="element-333" data-mp="qim1h3vo1gac">It’s the lack of a structured system for organizing and studying it.</span>
          </p>
          <p className="mt-5 text-base font-semibold text-brand sm:text-lg" data-id="element-334" data-mp="ih4vgb7jy51d">
            That’s why I created the Critical Care Nursing Blueprint™.
          </p>
        </div>

        <SectionCTA label="I want a structured critical care nursing reference" tone="dark" data-id="element-335" data-mp="sfu1n6q3611s" />
      </div>
    </section>;
}